// Investigate filter bar — currently inert.
//
// The legacy filter UI (entity-types fetch, chip builder, Show/Hide
// toolbar button) is no longer surfaced: filtering is driven by
// AI-generated chips + per-view Object Set. This component is kept so
// `InvestigateLayout` can mount something at the toolbar slot without a
// route refactor, and so the future filter UI has a known landing
// point. It does no network calls and renders nothing.

export function InvestigateFilterBar() {
  return null
}
